import"../dayjs.js";import dayjs from"../../node_modules/dayjs/dayjs.min.js";const displaySeconds=seconds=>typeof seconds>"u"||seconds===null?"":dayjs.duration(seconds,"seconds").humanize();export{displaySeconds};
